module.exports = __webpack_public_path__ + "static/media/wechat-qrocode.c5d7fd4d.jpeg";